export default {
  xxs: '360px',
  xs: '480px',
  ms: '600px',
  sm: '768px',
  md: '992px',
  lg: '1200px',
  xl: '1700px',
}
